export default __webpack_public_path__ + "static/media/wieprz.107def69.svg";